import gql from 'graphql-tag';

const CREATE_EMPLOYEE = gql`
  mutation(
    $firstName: String
    $lastName: String
    $email: String
    $phoneNumber: String
    $designation: DesignationInput
    $businessFunction: BusinessFunctionInput
    $team: TeamInput
    $role: RoleInput
  ) {
    createCompanyUser(
      input: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        phoneNumber: $phoneNumber
        designation: $designation
        businessFunction: $businessFunction
        team: $team
        role: $role
      }
    ) {
      userId
      firstName
      lastName
      email
      phoneNumber
      designation {
        designationId
        name
      }
      businessFunction {
        businessFunctionId
        name
      }
      team {
        teamId
        name
      }
      role {
        roleId
      }
    }
  }
`;

const UPDATE_EMPLOYEE = gql`
  mutation(
    $userId: ID!
    $firstName: String
    $lastName: String
    $email: String
    $phoneNumber: String
    $designation: DesignationInput
    $businessFunction: BusinessFunctionInput
    $team: TeamInput
  ) {
    updateCompanyUser(
      input: {
        userId: $userId
        firstName: $firstName
        lastName: $lastName
        email: $email
        phoneNumber: $phoneNumber
        designation: $designation
        businessFunction: $businessFunction
        team: $team
      }
    ) {
      userId
      firstName
      lastName
      email
      phoneNumber
      designation {
        designationId
        name
      }
      businessFunction {
        businessFunctionId
        name
      }
      team {
        teamId
        name
      }
    }
  }
`;

const GET_ALL_EMPLOYEES = gql`
  query {
    getAllEmployees {
      userId
      firstName
      lastName
      email
      phoneNumber
      contactNumber
      activated
      designation {
        designationId
        name
      }
      businessFunction {
        businessFunctionId
        name
      }
      team {
        teamId
        name
      }
    }
  }
`;

const GET_ALLMSP_DESIGNATIONS = gql`
  query {
    getDesignationList {
      designationId
      name
    }
  }
`;

const GET_MSP_BUSINESSFUNCTIONS = gql`
  query {
    getBusinessFunctionList {
      businessFunctionId
      name
    }
  }
`;

const GET_MSP_TEAMLIST = gql`
  query {
    getTeamList {
      teamId
      name
    }
  }
`;

export {
  UPDATE_EMPLOYEE,
  CREATE_EMPLOYEE,
  GET_ALL_EMPLOYEES,
  GET_ALLMSP_DESIGNATIONS,
  GET_MSP_BUSINESSFUNCTIONS,
  GET_MSP_TEAMLIST
};
